// TODO: create a middle man componet that takes mardown, cleans it and styles it
// TODO: improve image size and add skeleton
// TODO: update style by taking the blog out of a module
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
//import DOMPurify from 'dompurify'
import Modal from '../ui/Modal'
import Module from '../ui/Card'
import loadImage from '../../utils/loadImage'
// NOTE: components
import ExtendedMarkdown from '../extendedMarkdown/ExtendedMarkdown'

interface BlogProps {
	blog: any
	className?: string
	imgClassName?: string
	skeletonClassName: string
}

const Blog = ({ blog, className, imgClassName, skeletonClassName }: BlogProps) => {
	const [show, setShow] = useState(false)

	const { isLoading: isLoadingImageUrl, isError: isErrorImageUrl, error: errorImageUrl, data: imageUrl } = useQuery({
		queryKey: [blog.cover.url],
		queryFn: async () => {
			const response = await fetch(`/api/cms${blog.cover.url}`)

			await loadImage(response)
			return response.url ?? null
		}
	})
	
	if (isErrorImageUrl) console.error('Error loading blog image', errorImageUrl?.message)

	
	const enhancedBody = `# ${blog.title} \n ${blog.dek || ''} \n ![(${blog.cover.alternativeText || blog.title})](${imageUrl}) \n ${blog.body}`


	return (
		<>
			{/* NOTE: use display flex at the top level to prevent safari from breaking image and card when using columns css  */}
			<article className="flex">
				<Modal size="lg" show={show} onHide={() => setShow(false)}>
					<Modal.Header onHide={() => setShow(false)} />

					<Modal.Body className="mb-8 mx-4">
						<ExtendedMarkdown className="mx-auto md:prose-lg lg:prose-xl prose-img:max-h-[80vh]">
							{enhancedBody}
						</ExtendedMarkdown>
					</Modal.Body>
				</Modal>

				<Module className={`w-full !overflow-hidden ${className}`} onClick={() => setShow(true)}>
					{isLoadingImageUrl && <div className={`skeleton ${skeletonClassName} w-full`} />}

					{!isLoadingImageUrl && (
						<img
							src={imageUrl}
							alt={blog.cover.alternativeText ?? blog.title}
							className={`${imgClassName} w-full bg-[#d0dae6]`}
							loading="eager"
						/>
					)}

					<div className="min-h-[70px] px-4 pb-6 pt-4">
						<p className="text-dark mb-1 text-xl font-semibold leading-snug">{blog.title}</p>
						<p className="line-clamp-2 overflow-hidden text-ellipsis">{blog.dek}</p>
					</div>
				</Module>
			</article>
		</>
	)
}
export default Blog